import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const BonesOutline = createIcon({
  displayName: 'BonesOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M16.904 10.678h1.793c1.272 0 2.303-1.031 2.303-2.303v0c0-1.272-1.031-2.303-2.303-2.303h-.768v-.768c0-1.273-1.032-2.304-2.304-2.304v0c-1.272 0-2.303 1.031-2.303 2.303v1.793c0 .265-.105.52-.293.707l-5.226 5.226c-.188.188-.442.293-.707.293h-1.793c-1.272 1.77636e-15-2.303 1.031-2.303 2.303v0c0 1.272 1.031 2.303 2.303 2.303h.768v.768c8.88178e-16 1.273 1.032 2.304 2.304 2.304v0c1.272 0 2.303-1.031 2.303-2.303v-1.793c0-.265.105-.52.293-.707l5.226-5.226c.188-.188.442-.293.707-.293Z"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
    </>
  ),
})

const BonesTwoTone = createIcon({
  displayName: 'BonesTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor">
        <Box
          as="path"
          d="M16.904 10.678h1.793c1.272 0 2.303-1.031 2.303-2.303v0c0-1.272-1.031-2.303-2.303-2.303h-.768v-.768c0-1.273-1.032-2.304-2.304-2.304v0c-1.272 0-2.303 1.031-2.303 2.303v1.793c0 .265-.105.52-.293.707l-5.226 5.226c-.188.188-.442.293-.707.293h-1.793c-1.272 1.77636e-15-2.303 1.031-2.303 2.303v0c0 1.272 1.031 2.303 2.303 2.303h.768v.768c8.88178e-16 1.273 1.032 2.304 2.304 2.304v0c1.272 0 2.303-1.031 2.303-2.303v-1.793c0-.265.105-.52.293-.707l5.226-5.226c.188-.188.442-.293.707-.293Z"
          strokeLinecap="round"
          strokeWidth="1.5"
          stroke="currentColor"
          fill="twoToneFillColor"
          strokeLinejoin="round"
        ></Box>
        <path fill="none" d="M0 0h24v24h-24v-24Z"></path>
      </Box>
    </>
  ),
})

const Bones: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'twoTone':
      return <CustomIcon as={BonesTwoTone} {...props} />
    default:
      return <CustomIcon as={BonesOutline} {...props} />
  }
}

export default memo(Bones)
